export class ApplicationError extends Error {
    constructor(message) {
        super(message);
        this.name = this.constructor.name;
    }
}
export class NotImplementedError extends ApplicationError {
    constructor() {
        super('Operation not implemented');
    }
}
export class NotSupportedError extends ApplicationError {
    constructor(message) {
        super(message ?? 'Operation not supported');
    }
}
export class InvalidProgramStateError extends ApplicationError {
    constructor() {
        super('Invalid program state');
    }
}
export class InvalidArgumentError extends ApplicationError {
    constructor(argumentName, message) {
        super(message != undefined ? `${message} (argument: ${argumentName})` : `Invalid argument value: ${argumentName}`);
    }
}
export class TypingError extends ApplicationError {
    constructor() {
        super('Invalid typing');
    }
}
